// eslint-disable-next-line import/no-unused-modules
export const HEIGHT = 120;
export const WIDTH = 560;
export const RATIO = 0.35;

export const TOOLBAR_WIDTH = 50;

export const LINE_WIDTH_RATIO = 1300;
export const LINE_WIDTH_DIFF = 5;
